const Box = require('components/Box').default;
const Flex = require('components/Flex').default;
const Grid = require('components/Grid').default;
const Text = require('components/Text').default;
const Link = require('components/Link').default;
const Image = require('components/Image/Image').default;
const Container = require('components/Container').default;
const Divider = require('components/Divider').default;
const Button = require('components/Button').default;
const Icon = require('components/Icon').default;

const ui = {
    Box,
    Flex,
    Grid,
    Text,
    Link,
    Image,
    Container,
    Divider,
    Button,
    Icon
};

module.exports = ui;
